var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2209 21.63C13.0409 21.63 11.3709 20.8 10.0509 16.83L9.33086 14.67L7.17086 13.95C3.21086 12.63 2.38086 10.96 2.38086 9.78001C2.38086 8.61001 3.21086 6.93001 7.17086 5.60001L15.6609 2.77001C17.7809 2.06001 19.5509 2.27001 20.6409 3.35001C21.7309 4.43001 21.9409 6.21001 21.2309 8.33001L18.4009 16.82C17.0709 20.8 15.4009 21.63 14.2209 21.63ZM7.64086 7.03001C4.86086 7.96001 3.87086 9.06001 3.87086 9.78001C3.87086 10.5 4.86086 11.6 7.64086 12.52L10.1609 13.36C10.3809 13.43 10.5609 13.61 10.6309 13.83L11.4709 16.35C12.3909 19.13 13.5009 20.12 14.2209 20.12C14.9409 20.12 16.0409 19.13 16.9709 16.35L19.8009 7.86001C20.3109 6.32001 20.2209 5.06001 19.5709 4.41001C18.9209 3.76001 17.6609 3.68001 16.1309 4.19001L7.64086 7.03001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1108 14.4C9.92078 14.4 9.73078 14.33 9.58078 14.18C9.29078 13.89 9.29078 13.41 9.58078 13.12L13.1608 9.53C13.4508 9.24 13.9308 9.24 14.2208 9.53C14.5108 9.82 14.5108 10.3 14.2208 10.59L10.6408 14.18C10.5008 14.33 10.3008 14.4 10.1108 14.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCode);
export default __webpack_public_path__ + "static/media/send_code.df6eacf63650febd4bfe15b48d9ed108.svg";
export { ForwardRef as ReactComponent };